import classNames from "classnames";
import React, { ElementType } from "react";
import { HeadingProps } from "./types";

const Heading = ({
  children,
  className,
  color = "normal",
  href,
  level,
  isOnDarkCanvas = false,
  size = "medium",
  ...rest
}: HeadingProps) => {
  const headingClasses = classNames(
    "rds-Heading",
    {
      [`rds-Heading--${size}`]: size !== "medium",
      [`rds-Heading--${color}`]: color !== "normal",
      "on-darkCanvas": isOnDarkCanvas,
    },
    className
  );

  const Element: ElementType = `h${level}`;

  return (
    <Element className={headingClasses} {...rest}>
      {href ? <a href={href}>{children}</a> : children}
    </Element>
  );
};

Heading.displayName = "Heading";


export default Heading;
